import { render, staticRenderFns } from "./loginByStudentId.vue?vue&type=template&id=8e321f48&scoped=true"
import script from "./loginByStudentId.vue?vue&type=script&lang=js"
export * from "./loginByStudentId.vue?vue&type=script&lang=js"
import style0 from "./loginByStudentId.vue?vue&type=style&index=0&id=8e321f48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e321f48",
  null
  
)

export default component.exports